// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_17_2-button {
  /* Typography */
  --perxis-auto-button-font-family-inner: var(
    --perxis-auto-button-font-family,
    var(--perxis-auto-root-typography-font-family-inner)
  );
  --perxis-auto-button-font-variant-numeric-inner: var(
    --perxis-auto-button-font-variant-numeric,
    var(--perxis-auto-root-typography-font-variant-numeric-inner)
  );
  --perxis-auto-button-font-size-inner: var(--perxis-auto-button-font-size, 12px);
  --perxis-auto-button-font-weight-inner: var(--perxis-auto-button-font-weight, 700);
  --perxis-auto-button-letter-spacing-inner: var(--perxis-auto-button-letter-spacing, 0.04em);
  --perxis-auto-button-line-height-inner: var(--perxis-auto-button-line-height, 1.5);
  --perxis-auto-button-text-transform-inner: var(--perxis-auto-button-text-transform, uppercase);
  --perxis-auto-button-text-decoration-inner: var(--perxis-auto-button-text-decoration, none);
  --perxis-auto-button-icon-font-size-inner: var(--perxis-auto-button-icon-font-size, 18px);
  /* End Typography */
  /* Colors */
  --perxis-auto-button-first-color-inner: var(
    --perxis-auto-button-first-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-button-second-color-inner: var(
    --perxis-auto-button-second-color,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-button-third-color-inner: var(
    --perxis-auto-button-third-color,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-button-fourth-color-inner: var(
    --perxis-auto-button-fourth-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  /* End Colors */
  /* Primary */
  --perxis-auto-button-primary-background-color-inner: var(
    --perxis-auto-button-primary-background-color,
    var(--perxis-auto-button-second-color-inner)
  );
  --perxis-auto-button-primary-disabled-background-color-inner: var(
    --perxis-auto-button-primary-disabled-background-color,
    var(--perxis-auto-button-fourth-color-inner)
  );
  --perxis-auto-button-primary-hover-background-color-inner: var(
    --perxis-auto-button-primary-hover-background-color,
    var(--perxis-auto-button-third-color-inner)
  );
  --perxis-auto-button-primary-active-background-color-inner: var(
    --perxis-auto-button-primary-active-background-color,
    var(--perxis-auto-button-primary-hover-background-color-inner)
  );
  --perxis-auto-button-primary-border-color-inner: var(
    --perxis-auto-button-primary-border-color,
    var(--perxis-auto-button-second-color-inner)
  );
  --perxis-auto-button-primary-disabled-border-color-inner: var(
    --perxis-auto-button-primary-disabled-border-color,
    var(--perxis-auto-button-fourth-color-inner)
  );
  --perxis-auto-button-primary-hover-border-color-inner: var(
    --perxis-auto-button-primary-hover-border-color,
    var(--perxis-auto-button-third-color-inner)
  );
  --perxis-auto-button-primary-active-border-color-inner: var(
    --perxis-auto-button-primary-active-border-color,
    var(--perxis-auto-button-primary-hover-border-color-inner)
  );
  --perxis-auto-button-primary-color-inner: var(
    --perxis-auto-button-primary-color,
    var(--perxis-auto-button-first-color-inner)
  );
  --perxis-auto-button-primary-disabled-color-inner: var(
    --perxis-auto-button-primary-disabled-color,
    var(--perxis-auto-button-first-color-inner)
  );
  --perxis-auto-button-primary-hover-color-inner: var(
    --perxis-auto-button-primary-hover-color,
    var(--perxis-auto-button-first-color-inner)
  );
  --perxis-auto-button-primary-active-color-inner: var(
    --perxis-auto-button-primary-active-color,
    var(--perxis-auto-button-primary-hover-color-inner)
  );
  --perxis-auto-button-primary-icon-color-inner: var(
    --perxis-auto-button-primary-icon-color,
    var(--perxis-auto-button-first-color-inner)
  );
  --perxis-auto-button-primary-disabled-icon-color-inner: var(
    --perxis-auto-button-primary-disabled-icon-color,
    var(--perxis-auto-button-first-color-inner)
  );
  --perxis-auto-button-primary-hover-icon-color-inner: var(
    --perxis-auto-button-primary-hover-icon-color,
    var(--perxis-auto-button-first-color-inner)
  );
  --perxis-auto-button-primary-active-icon-color-inner: var(
    --perxis-auto-button-primary-active-icon-color,
    var(--perxis-auto-button-primary-hover-icon-color-inner)
  );
  /* End Primary */
  /* Ghost */
  --perxis-auto-button-ghost-background-color-inner: var(--perxis-auto-button-ghost-background-color, transparent);
  --perxis-auto-button-ghost-disabled-background-color-inner: var(
    --perxis-auto-button-ghost-disabled-background-color,
    var(--perxis-auto-button-ghost-background-color-inner)
  );
  --perxis-auto-button-ghost-hover-background-color-inner: var(
    --perxis-auto-button-ghost-hover-background-color,
    var(--perxis-auto-button-third-color-inner)
  );
  --perxis-auto-button-ghost-active-background-color-inner: var(
    --perxis-auto-button-ghost-active-background-color,
    var(--perxis-auto-button-ghost-hover-background-color-inner)
  );
  --perxis-auto-button-ghost-border-color-inner: var(
    --perxis-auto-button-ghost-border-color,
    var(--perxis-auto-button-second-color-inner)
  );
  --perxis-auto-button-ghost-disabled-border-color-inner: var(
    --perxis-auto-button-ghost-disabled-border-color,
    var(--perxis-auto-button-fourth-color-inner)
  );
  --perxis-auto-button-ghost-hover-border-color-inner: var(
    --perxis-auto-button-ghost-hover-border-color,
    var(--perxis-auto-button-third-color-inner)
  );
  --perxis-auto-button-ghost-active-border-color-inner: var(
    --perxis-auto-button-ghost-active-border-color,
    var(--perxis-auto-button-ghost-hover-border-color-inner)
  );
  --perxis-auto-button-ghost-color-inner: var(
    --perxis-auto-button-ghost-color,
    var(--perxis-auto-button-second-color-inner)
  );
  --perxis-auto-button-ghost-disabled-color-inner: var(
    --perxis-auto-button-ghost-disabled-color,
    var(--perxis-auto-button-fourth-color-inner)
  );
  --perxis-auto-button-ghost-hover-color-inner: var(
    --perxis-auto-button-ghost-hover-color,
    var(--perxis-auto-button-first-color-inner)
  );
  --perxis-auto-button-ghost-active-color-inner: var(
    --perxis-auto-button-ghost-active-color,
    var(--perxis-auto-button-ghost-hover-color-inner)
  );
  --perxis-auto-button-ghost-icon-color-inner: var(
    --perxis-auto-button-ghost-icon-color,
    var(--perxis-auto-button-second-color-inner)
  );
  --perxis-auto-button-ghost-disabled-icon-color-inner: var(
    --perxis-auto-button-ghost-disabled-icon-color,
    var(--perxis-auto-button-fourth-color-inner)
  );
  --perxis-auto-button-ghost-hover-icon-color-inner: var(
    --perxis-auto-button-ghost-hover-icon-color,
    var(--perxis-auto-button-first-color-inner)
  );
  --perxis-auto-button-ghost-active-icon-color-inner: var(
    --perxis-auto-button-ghost-active-icon-color,
    var(--perxis-auto-button-ghost-hover-icon-color-inner)
  );
  /* End Ghost */
  /* Text */
  --perxis-auto-button-text-background-color-inner: var(--perxis-auto-button-text-background-color, transparent);
  --perxis-auto-button-text-border-bottom-inner: var(--perxis-auto-button-text-border-bottom, none);
  --perxis-auto-button-text-color-inner: var(
    --perxis-auto-button-text-color,
    var(--perxis-auto-button-second-color-inner)
  );
  --perxis-auto-button-text-hover-background-color-inner: var(
    --perxis-auto-button-text-hover-background-color,
    transparent
  );
  --perxis-auto-button-text-hover-color-inner: var(
    --perxis-auto-button-text-hover-color,
    var(--perxis-auto-button-second-color-inner)
  );
  --perxis-auto-button-text-icon-color-inner: var(
    --perxis-auto-button-text-icon-color,
    var(--perxis-auto-button-second-color-inner)
  );
  --perxis-auto-button-text-icon-hover-color-inner: var(
    --perxis-auto-button-text-icon-hover-color,
    var(--perxis-auto-button-second-color-inner)
  );
  --perxis-auto-button-text-text-decoration-line-inner: var(--perxis-auto-button-text-text-decoration-line, none);
  --perxis-auto-button-text-hover-text-decoration-line-inner: var(
    --perxis-auto-button-text-hover-text-decoration-line,
    var(--perxis-auto-button-text-text-decoration-line-inner)
  );
  --perxis-auto-button-text-text-decoration-style-inner: var(--perxis-auto-button-text-text-decoration-style, initial);
  --perxis-auto-button-text-hover-text-decoration-style-inner: var(
    --perxis-auto-button-text-hover-text-decoration-style,
    var(--perxis-auto-button-text-text-decoration-style-inner)
  );
  --perxis-auto-button-text-text-underline-offset-inner: var(--perxis-auto-button-text-text-underline-offset, auto);
  --perxis-auto-button-text-hover-text-underline-offset-inner: var(
    --perxis-auto-button-text-hover-text-underline-offset,
    var(--perxis-auto-button-text-text-underline-offset-inner)
  );
  /* End Text */
  /* Link */
  --perxis-auto-button-link-font-family-inner: var(
    --perxis-auto-button-link-font-family,
    var(--perxis-auto-button-font-family-inner)
  );
  --perxis-auto-button-link-font-size-inner: var(
    --perxis-auto-button-link-font-size,
    var(--perxis-auto-button-font-size-inner)
  );
  --perxis-auto-button-link-font-weight-inner: var(
    --perxis-auto-button-link-font-weight,
    var(--perxis-auto-button-font-weight-inner)
  );
  --perxis-auto-button-link-letter-spacing-inner: var(
    --perxis-auto-button-link-letter-spacing,
    var(--perxis-auto-button-letter-spacing-inner)
  );
  --perxis-auto-button-link-line-height-inner: var(
    --perxis-auto-button-link-line-height,
    var(--perxis-auto-button-line-height-inner)
  );
  --perxis-auto-button-link-text-transform-inner: var(
    --perxis-auto-button-link-text-transform,
    var(--perxis-auto-button-text-transform-inner)
  );
  --perxis-auto-button-link-background-color-inner: var(--perxis-auto-button-link-background-color, transparent);
  --perxis-auto-button-link-hover-background-color-inner: var(
    --perxis-auto-button-link-hover-background-color,
    transparent
  );
  --perxis-auto-button-link-active-background-color-inner: var(
    --perxis-auto-button-link-active-background-color,
    var(--perxis-auto-button-link-hover-background-color-inner)
  );
  --perxis-auto-button-link-color-inner: var(
    --perxis-auto-button-link-color,
    var(--perxis-auto-button-second-color-inner)
  );
  --perxis-auto-button-link-hover-color-inner: var(
    --perxis-auto-button-link-hover-color,
    var(--perxis-auto-button-third-color-inner)
  );
  --perxis-auto-button-link-active-color-inner: var(
    --perxis-auto-button-link-active-color,
    var(--perxis-auto-button-link-hover-color-inner)
  );
  --perxis-auto-button-link-icon-color-inner: var(
    --perxis-auto-button-link-icon-color,
    var(--perxis-auto-button-second-color-inner)
  );
  --perxis-auto-button-link-icon-hover-color-inner: var(
    --perxis-auto-button-link-icon-hover-color,
    var(--perxis-auto-button-third-color-inner)
  );
  --perxis-auto-button-link-icon-active-color-inner: var(
    --perxis-auto-button-link-icon-active-color,
    var(--perxis-auto-button-link-icon-hover-color-inner)
  );
  /* End Link */
  /* Border */
  --perxis-auto-button-border-radius-inner: var(--perxis-auto-button-border-radius, 8px);
  --perxis-auto-button-border-width-inner: var(--perxis-auto-button-border-width, 2px);
  --perxis-auto-button-icon-only-border-radius-inner: var(
    --perxis-auto-button-icon-only-border-radius,
    var(--perxis-auto-button-border-radius-inner)
  );
  /* End Border */
  /* Opacity */
  --perxis-auto-button-primary-opacity-inner: var(--perxis-auto-button-primary-opacity, 1);
  --perxis-auto-button-primary-hover-opacity-inner: var(--perxis-auto-button-primary-hover-opacity, 1);
  --perxis-auto-button-primary-active-opacity-inner: var(--perxis-auto-button-primary-active-opacity, 1);
  --perxis-auto-button-primary-disabled-opacity-inner: var(--perxis-auto-button-primary-disabled-opacity, 1);
  --perxis-auto-button-ghost-opacity-inner: var(--perxis-auto-button-ghost-opacity, 1);
  --perxis-auto-button-ghost-hover-opacity-inner: var(--perxis-auto-button-ghost-hover-opacity, 1);
  --perxis-auto-button-ghost-active-opacity-inner: var(--perxis-auto-button-ghost-active-opacity, 1);
  --perxis-auto-button-ghost-disabled-opacity-inner: var(--perxis-auto-button-ghost-disabled-opacity, 1);
  /* End Opacity */
  /* Box Shadow */
  --perxis-auto-button-primary-box-shadow-inner: var(--perxis-auto-button-primary-box-shadow, none);
  --perxis-auto-button-primary-hover-box-shadow-inner: var(--perxis-auto-button-primary-hover-box-shadow, none);
  --perxis-auto-button-primary-active-box-shadow-inner: var(--perxis-auto-button-primary-active-box-shadow, none);
  --perxis-auto-button-ghost-box-shadow-inner: var(--perxis-auto-button-ghost-box-shadow, none);
  --perxis-auto-button-ghost-hover-box-shadow-inner: var(--perxis-auto-button-ghost-hover-box-shadow, none);
  --perxis-auto-button-ghost-active-box-shadow-inner: var(--perxis-auto-button-ghost-active-box-shadow, none);
  /* End Box Shadow */
  /* Flex */
  --perxis-auto-button-justify-content-inner: var(--perxis-auto-button-justify-content, space-between);
  /* End Flex */
  /* Gap */
  --perxis-auto-button-padding-inner: var(--perxis-auto-button-padding, 14px 24px);
  --perxis-auto-button-icon-only-padding-inner: var(--perxis-auto-button-icon-only-padding, 14px);
  --perxis-auto-button-icon-gap-normal-inner: var(--perxis-auto-button-icon-gap-normal, 10px);
  --perxis-auto-button-icon-gap-large-inner: var(--perxis-auto-button-icon-gap-large, 18px);
  /* End Gap */
  --antd-wave-shadow-color: transparent;
  --wave-color: transparent;
}
.perxis-auto-1_17_2-button[ant-5_24_1-click-animating-without-extra-node=true]::after,
.perxis-auto-1_17_2-button > *[ant-5_24_1-click-animating-without-extra-node=true]::after {
  animation: none !important;
}
.perxis-auto-1_17_2-button .ant-5_24_1-wave {
  transition: none !important;
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn {
  display: inline-flex;
  align-items: center;
  justify-content: inherit;
  font-family: var(--perxis-auto-button-font-family-inner);
  font-size: var(--perxis-auto-button-font-size-inner);
  line-height: var(--perxis-auto-button-line-height-inner);
  font-weight: var(--perxis-auto-button-font-weight-inner);
  text-transform: var(--perxis-auto-button-text-transform-inner);
  text-decoration: var(--perxis-auto-button-text-decoration-inner);
  letter-spacing: var(--perxis-auto-button-letter-spacing-inner);
  font-variant-numeric: var(--perxis-auto-button-font-variant-numeric-inner);
  border-radius: var(--perxis-auto-button-border-radius-inner);
  height: unset;
  min-height: 50px;
  padding: var(--perxis-auto-button-padding-inner);
  box-shadow: none;
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn:is(a) {
  display: inline-flex !important;
  line-height: var(--perxis-auto-button-line-height-inner) !important;
  padding: var(--perxis-auto-button-padding-inner) !important;
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn > span:not(.ant-5_24_1-btn-icon) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--with-icon {
  justify-content: var(--perxis-auto-button-justify-content-inner);
  align-items: center;
  column-gap: 0;
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--with-icon .ant-5_24_1-btn-icon {
  font-size: var(--perxis-auto-button-icon-font-size-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-icon {
  transition: fill 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--icon-position-left {
  flex-direction: row;
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--icon-position-left.perxis-auto-1_17_2-button--icon-gap-normal > span:not(.ant-5_24_1-btn-icon) {
  margin-left: var(--perxis-auto-button-icon-gap-normal-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--icon-position-left.perxis-auto-1_17_2-button--icon-gap-large > span:not(.ant-5_24_1-btn-icon) {
  margin-left: var(--perxis-auto-button-icon-gap-large-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--icon-position-right {
  flex-direction: row-reverse;
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--icon-position-right.perxis-auto-1_17_2-button--icon-gap-normal > span:not(.ant-5_24_1-btn-icon) {
  margin-right: var(--perxis-auto-button-icon-gap-normal-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--icon-position-right.perxis-auto-1_17_2-button--icon-gap-large > span:not(.ant-5_24_1-btn-icon) {
  margin-right: var(--perxis-auto-button-icon-gap-large-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn > .ant-5_24_1-btn-icon {
  margin: 0 !important;
  line-height: 0;
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--icon-only {
  justify-content: center;
  height: 32px;
  width: auto;
  border-width: var(--perxis-auto-button-border-width-inner) !important;
  padding: var(--perxis-auto-button-icon-only-padding-inner);
  border-radius: var(--perxis-auto-button-icon-only-border-radius-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn .perxis-auto-1_17_2-button__icon {
  display: inline-flex;
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn:not(:disabled):focus-visible {
  outline: none;
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text {
  background-color: var(--perxis-auto-button-text-background-color-inner) !important;
  border: none !important;
  height: auto !important;
  width: auto !important;
  min-height: auto !important;
  padding: 0 !important;
  color: var(--perxis-auto-button-text-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text > span:not(.ant-5_24_1-btn-icon) {
  border-bottom: var(--perxis-auto-button-text-border-bottom-inner) !important;
  text-decoration-line: var(--perxis-auto-button-text-text-decoration-line-inner);
  text-decoration-style: var(--perxis-auto-button-text-text-decoration-style-inner);
  text-underline-offset: var(--perxis-auto-button-text-text-underline-offset-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon {
  color: var(--perxis-auto-button-text-icon-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg {
  fill: var(--perxis-auto-button-text-icon-color-inner);
}
@media (hover: none) {
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled) {
    background-color: var(--perxis-auto-button-text-hover-background-color-inner);
    color: var(--perxis-auto-button-text-hover-color-inner);
  }
}
@media (hover: hover) {
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):hover {
    background-color: var(--perxis-auto-button-text-hover-background-color-inner);
    color: var(--perxis-auto-button-text-hover-color-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):hover > span:not(.ant-5_24_1-btn-icon) {
    text-decoration-line: var(--perxis-auto-button-text-hover-text-decoration-line-inner);
    text-decoration-style: var(--perxis-auto-button-text-hover-text-decoration-style-inner);
    text-underline-offset: var(--perxis-auto-button-text-hover-text-underline-offset-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):hover .ant-5_24_1-typography {
    color: var(--perxis-auto-button-text-hover-color-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):hover.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon {
    color: var(--perxis-auto-button-text-icon-hover-color-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):hover.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg {
    fill: var(--perxis-auto-button-text-icon-hover-color-inner);
  }
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):active, .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):focus-visible {
  background-color: var(--perxis-auto-button-text-hover-background-color-inner);
  color: var(--perxis-auto-button-text-hover-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):active > span:not(.ant-5_24_1-btn-icon), .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):focus-visible > span:not(.ant-5_24_1-btn-icon) {
  text-decoration-line: var(--perxis-auto-button-text-hover-text-decoration-line-inner);
  text-decoration-style: var(--perxis-auto-button-text-hover-text-decoration-style-inner);
  text-underline-offset: var(--perxis-auto-button-text-hover-text-underline-offset-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):active .ant-5_24_1-typography, .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):focus-visible .ant-5_24_1-typography {
  color: var(--perxis-auto-button-text-hover-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):active.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon, .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):focus-visible.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon {
  color: var(--perxis-auto-button-text-icon-hover-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):active.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg, .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-text:not(:disabled):focus-visible.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg {
  fill: var(--perxis-auto-button-text-icon-hover-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-link {
  background-color: var(--perxis-auto-button-link-background-color-inner);
  border: none !important;
  height: auto !important;
  width: auto !important;
  min-height: auto !important;
  padding: 0 !important;
  color: var(--perxis-auto-button-link-color-inner);
  font-family: var(--perxis-auto-button-link-font-family-inner);
  font-size: var(--perxis-auto-button-link-font-size-inner);
  line-height: var(--perxis-auto-button-link-line-height-inner);
  font-weight: var(--perxis-auto-button-link-font-weight-inner);
  text-transform: var(--perxis-auto-button-link-text-transform-inner);
  letter-spacing: var(--perxis-auto-button-link-letter-spacing-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-link.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon {
  color: var(--perxis-auto-button-link-icon-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-link.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg {
  fill: var(--perxis-auto-button-link-icon-color-inner);
}
@media (hover: none) {
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-link:not(:disabled):hover {
    color: var(--perxis-auto-button-link-color-inner);
    background-color: var(--perxis-auto-button-link-hover-background-color-inner);
  }
}
@media (hover: hover) {
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-link:not(:disabled):hover {
    background-color: var(--perxis-auto-button-link-hover-background-color-inner);
    color: var(--perxis-auto-button-link-hover-color-inner);
    opacity: var(--perxis-auto-button-link-hover-opacity-inner);
    box-shadow: var(--perxis-auto-button-link-hover-box-shadow-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-link:not(:disabled):hover.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon {
    color: var(--perxis-auto-button-link-icon-hover-color-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-link:not(:disabled):hover.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg {
    fill: var(--perxis-auto-button-link-icon-hover-color-inner);
  }
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-link:not(:disabled):active {
  background-color: var(--perxis-auto-button-link-active-background-color-inner);
  border-color: var(--perxis-auto-button-link-active-border-color-inner);
  color: var(--perxis-auto-button-link-active-color-inner);
  opacity: var(--perxis-auto-button-link-hover-opacity-inner);
  box-shadow: var(--perxis-auto-button-link-hover-box-shadow-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-link:not(:disabled):active.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon {
  color: var(--perxis-auto-button-link-icon-active-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-link:not(:disabled):active.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg {
  fill: var(--perxis-auto-button-link-icon-active-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-primary {
  background-color: var(--perxis-auto-button-primary-background-color-inner);
  color: var(--perxis-auto-button-primary-color-inner);
  border-color: var(--perxis-auto-button-primary-border-color-inner);
  border-width: var(--perxis-auto-button-border-width-inner);
  opacity: var(--perxis-auto-button-primary-opacity-inner);
  box-shadow: var(--perxis-auto-button-primary-box-shadow-inner);
  border-style: solid;
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-primary.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon {
  color: var(--perxis-auto-button-primary-icon-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-primary.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg {
  fill: var(--perxis-auto-button-primary-icon-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-primary:disabled {
  background-color: var(--perxis-auto-button-primary-disabled-background-color-inner);
  border-color: var(--perxis-auto-button-primary-disabled-border-color-inner);
  color: var(--perxis-auto-button-primary-disabled-color-inner);
  opacity: var(--perxis-auto-button-primary-disabled-opacity-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-primary:disabled.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon {
  color: var(--perxis-auto-button-primary-disabled-icon-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-primary:disabled.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg {
  fill: var(--perxis-auto-button-primary-disabled-icon-color-inner);
}
@media (hover: none) {
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-primary:not(:disabled):hover {
    color: var(--perxis-auto-button-primary-color-inner);
    border-color: var(--perxis-auto-button-primary-border-color-inner);
    background-color: var(--perxis-auto-button-primary-background-color-inner);
  }
}
@media (hover: hover) {
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-primary:not(:disabled):hover {
    background-color: var(--perxis-auto-button-primary-hover-background-color-inner);
    border-color: var(--perxis-auto-button-primary-hover-border-color-inner);
    color: var(--perxis-auto-button-primary-hover-color-inner);
    opacity: var(--perxis-auto-button-primary-hover-opacity-inner);
    box-shadow: var(--perxis-auto-button-primary-hover-box-shadow-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-primary:not(:disabled):hover.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon {
    color: var(--perxis-auto-button-primary-hover-icon-color-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-primary:not(:disabled):hover.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg {
    fill: var(--perxis-auto-button-primary-hover-icon-color-inner);
  }
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-primary:not(:disabled):active {
  background-color: var(--perxis-auto-button-primary-active-background-color-inner);
  border-color: var(--perxis-auto-button-primary-active-border-color-inner);
  color: var(--perxis-auto-button-primary-active-color-inner);
  opacity: var(--perxis-auto-button-primary-active-opacity-inner);
  box-shadow: var(--perxis-auto-button-primary-active-box-shadow-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-primary:not(:disabled):active.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon {
  color: var(--perxis-auto-button-primary-active-icon-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-primary:not(:disabled):active.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg {
  fill: var(--perxis-auto-button-primary-active-icon-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-ghost {
  background-color: var(--perxis-auto-button-ghost-background-color-inner);
  color: var(--perxis-auto-button-ghost-color-inner);
  border-color: var(--perxis-auto-button-ghost-border-color-inner);
  border-width: var(--perxis-auto-button-border-width-inner);
  opacity: var(--perxis-auto-button-ghost-opacity-inner);
  box-shadow: var(--perxis-auto-button-ghost-box-shadow-inner);
  border-style: solid;
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-ghost.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon {
  color: var(--perxis-auto-button-ghost-icon-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-ghost.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg {
  fill: var(--perxis-auto-button-ghost-icon-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-ghost:disabled {
  background-color: var(--perxis-auto-button-ghost-disabled-background-color-inner);
  border-color: var(--perxis-auto-button-ghost-disabled-border-color-inner);
  color: var(--perxis-auto-button-ghost-disabled-color-inner);
  box-shadow: var(--perxis-auto-button-ghost-hover-box-shadow-inner);
  opacity: var(--perxis-auto-button-ghost-disabled-opacity-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-ghost:disabled.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon {
  color: var(--perxis-auto-button-ghost-disabled-icon-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-ghost:disabled.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg {
  fill: var(--perxis-auto-button-ghost-disabled-icon-color-inner);
}
@media (hover: none) {
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-ghost:not(:disabled):hover {
    color: var(--perxis-auto-button-ghost-color-inner);
    border-color: var(--perxis-auto-button-ghost-border-color-inner);
    background-color: var(--perxis-auto-button-ghost-background-color-inner);
  }
}
@media (hover: hover) {
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-ghost:not(:disabled):hover {
    background-color: var(--perxis-auto-button-ghost-hover-background-color-inner);
    border-color: var(--perxis-auto-button-ghost-hover-border-color-inner);
    color: var(--perxis-auto-button-ghost-hover-color-inner);
    opacity: var(--perxis-auto-button-ghost-hover-opacity-inner);
    box-shadow: var(--perxis-auto-button-ghost-hover-box-shadow-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-ghost:not(:disabled):hover.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon {
    color: var(--perxis-auto-button-ghost-hover-icon-color-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-ghost:not(:disabled):hover.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg {
    fill: var(--perxis-auto-button-ghost-hover-icon-color-inner);
  }
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-ghost:not(:disabled):active {
  background-color: var(--perxis-auto-button-ghost-active-background-color-inner);
  border-color: var(--perxis-auto-button-ghost-active-border-color-inner);
  color: var(--perxis-auto-button-ghost-active-color-inner);
  opacity: var(--perxis-auto-button-ghost-active-opacity-inner);
  box-shadow: var(--perxis-auto-button-ghost-active-box-shadow-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-ghost:not(:disabled):active.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon {
  color: var(--perxis-auto-button-ghost-active-icon-color-inner);
}
.perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button-ghost:not(:disabled):active.perxis-auto-1_17_2-button--with-icon .perxis-auto-1_17_2-button__icon svg {
  fill: var(--perxis-auto-button-ghost-active-icon-color-inner);
}
@media (max-width: 479px) {
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-xxs {
    width: 100%;
    justify-content: center;
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-xxs.perxis-auto-1_17_2-button--with-icon {
    justify-content: var(--perxis-auto-button-justify-content-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-xxs.perxis-auto-1_17_2-button--icon-only {
    justify-content: center;
  }
}
@media (max-width: 575px) {
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-xs {
    width: 100%;
    justify-content: center;
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-xs.perxis-auto-1_17_2-button--with-icon {
    justify-content: var(--perxis-auto-button-justify-content-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-xs.perxis-auto-1_17_2-button--icon-only {
    justify-content: center;
  }
}
@media (max-width: 767px) {
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-sm {
    width: 100%;
    justify-content: center;
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-sm.perxis-auto-1_17_2-button--with-icon {
    justify-content: var(--perxis-auto-button-justify-content-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-sm.perxis-auto-1_17_2-button--icon-only {
    justify-content: center;
  }
}
@media (max-width: 991px) {
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-md {
    width: 100%;
    justify-content: center;
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-md.perxis-auto-1_17_2-button--with-icon {
    justify-content: var(--perxis-auto-button-justify-content-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-md.perxis-auto-1_17_2-button--icon-only {
    justify-content: center;
  }
}
@media (max-width: 1199px) {
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-lg {
    width: 100%;
    justify-content: center;
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-lg.perxis-auto-1_17_2-button--with-icon {
    justify-content: var(--perxis-auto-button-justify-content-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-lg.perxis-auto-1_17_2-button--icon-only {
    justify-content: center;
  }
}
@media (max-width: 1599px) {
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-xl {
    width: 100%;
    justify-content: center;
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-xl.perxis-auto-1_17_2-button--with-icon {
    justify-content: var(--perxis-auto-button-justify-content-inner);
  }
  .perxis-auto-1_17_2-button.ant-5_24_1-btn.perxis-auto-1_17_2-button--full-width-xl.perxis-auto-1_17_2-button--icon-only {
    justify-content: center;
  }
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
